<template>
    <section class="container__body container__body--xsm">

        <form class="col-12" @submit.prevent="submitOption">

            <section class="col-12 margin-b-75">

                <label>Navn på ret</label>

                <input class="col-12" type="text" name="name" placeholder="Hvad er navnet på tilvalget?" minlength="4" maxlength="120" required v-model="option.title">

            </section>

            <section class="col-12 margin-b-75">

                <label>Beskrivelse af ret</label>

                <textarea class="col-12" rows="4" name="name" placeholder="Hvad er tilvalgets beskrivelse?" minlength="4" v-model="option.description"></textarea>

            </section>

            <section class="col-12 margin-b-75">

                <label>Pris på ret som Premium</label>

                <section class="unit">

                    <input class="col-12" type="text" name="price" placeholder="Hvad er prisen pr. kuvert?" required v-model="priceFormatted">

                    <span>DKK</span>

                </section>

            </section>

            <section class="col-12 margin-b-75">

                <label>Pris på ret som Tilkøb</label>

                <section class="unit">

                    <input class="col-12" type="text" name="price" placeholder="Hvad er prisen pr. kuvert som tilkøb?" required v-model="extraPriceFormatted">

                    <span>DKK</span>

                </section>

            </section>

            <section class="col-12 margin-b-75">

                <label>Emballagepris</label>

                <section class="unit">

                    <input class="col-12" type="text" name="price" placeholder="Hvad er emballage prisen pr. kuvert som tilkøb?" required v-model="packagingPriceFormatted">

                    <span>DKK</span>

                </section>

            </section>

            <section class="col-12 margin-b-75">

                <label>Allergener</label>

                <section class="checkbox-wrap col-12 margin-t-15">

                    <label v-for="tag in tagsChecked"><input type="checkbox" :checked="tag.checked" @change="toggleTag(tag.id)"> {{tag.name}}</label>

                </section>

            </section>

            <image-upload v-model="option.image"></image-upload>

            <section class="col-12 margin-t-75">

                <label>Billedets SEO titel</label>

                <input class="col-12" type="text" name="image_name" placeholder="Hvad er billedets SEO titel?" v-model="option.image_name">

            </section>

            <section class="col-12 margin-t-75">

                <label>Rettens status</label>

                <section class="checkbox-wrap col-12 margin-t-15">

                    <label><input type="checkbox" v-model="option.sold_out"> Udsolgt</label>

                </section>
            </section>

            <section class="col-12 margin-t-75">

                <button type="submit" class="btn btn--md btn--primary primary--copper" :disabled="!validateForm || isSaving">

                    <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                    <span v-else>Gem & fortsæt</span>

                </button>

            </section>

        </form>

        <ws-modal v-model="noMoreIcons">

            <div class="modal-wrap">

                <div class="modal--sm center">

                    <span class="close" @click.prevent="noMoreIcons = false"><i class="fas fa-times"></i></span>

                    <h1>Ikke flere pakke ikoner</h1>

                    <p>Der er ikke flere tilgængelige pakke ikoner. Denne besked er også automatisk sendt videre til den tekniske afdeling</p>

                    <div class="col-12 margin-t-25">

                        <a href="#" @click.prevent="noMoreIcons = false">Ok</a>

                    </div>

                </div>

            </div>

        </ws-modal>

    </section>
</template>

<script>
	import ImageUpload from './../../../partials/imageUpload.vue';
    import {mapGetters} from "vuex";
    import tags from "../../../store/modules/tags";
    import {isInteger} from "lodash";
    export default {
        name: "create-option",
        data() {
            return {
				option: {
				    title:'',
                    description:'',
					price:'',
					image:'',
					image_name:'',
                    tags:[],
                    as_extra_price:'',
                    packaging_price:'',
                    sold_out: false,
				},
				isSaving:false,
				originalImage:'',
                noMoreIcons: false,
			};
        },
		components:{
          	ImageUpload,
		},
        computed: {
            ...mapGetters(['tags']),
            isCreating() {
                return this.$route.params.option == null;
            },
			priceFormatted:{
                get(){
                    return (this.option.price !== '') ? this.stripeAmount(this.option.price).amountForEditing:'';
				},
				set(value){
                    this.option.price = this.amountToStripe(value);
				}
			},
            extraPriceFormatted:{
                get(){
                    return (this.option.as_extra_price !== '') ? this.stripeAmount(this.option.as_extra_price).amountForEditing:'';
                },
                set(value){
                    this.option.as_extra_price = this.amountToStripe(value);
                }
            },
            packagingPriceFormatted:{
                get(){
                    return (this.option.packaging_price !== '') ? this.stripeAmount(this.option.packaging_price).amountForEditing:'';
                },
                set(value){
                    this.option.packaging_price = this.amountToStripe(value);
                }
            },
            tagsChecked(){
                return this.tags.map(tag => {
                    return {
                        id: tag.id,
                        name: tag.name,
                        checked: this.option.tags.includes(tag.id),
                    }
                })
            },
			validateName(){
                return this.option.title !== '' && String(this.option.title).length > 0;
			},
			validatePrice(){
                return isInteger(this.option.price) && this.option.price > 0;
			},
            validateAsExtraPrice(){
                return isInteger(this.option.as_extra_price) && this.option.as_extra_price > 0;
            },
            validatePackagingPrice(){
                return isInteger(this.option.packaging_price);
            },
			validateImage(){
                return this.option.image !== '' && this.option.image !== null;
			},
			validateImageName(){
               if(this.option.image === this.originalImage){
                   return true;
			   }

			   return this.option.image_name !== '' && String(this.option.image_name).length > 0;
			},
			validateForm(){
                return this.validateName && this.validatePrice && this.validateAsExtraPrice && this.validatePackagingPrice && this.validateImage && this.validateImageName;
			},
        },
		methods:{
            submitOption(){
                if(!this.validateForm){
                    return;
                }

                if(this.isCreating){
                    console.log('is creating');
                    return this.createOption();
                }
                console.log('is updating');
                this.updateOption();
            },
            createOption(){
                this.isSaving = true;
                let formData = new FormData();
                formData.append('title', this.option.title);
                formData.append('description', this.option.description);
                formData.append('price', this.option.price);
				formData.append('image', this.option.image);
				formData.append('image_name', this.option.image_name);
				formData.append('as_extra_price', this.option.as_extra_price);
				formData.append('packaging_price', this.option.packaging_price);
                formData.append('sold_out', this.option.sold_out);

                this.option.tags.forEach((tag)=>{
                    formData.append('tags[]', tag);
                })

                axios.post(`/api/admin/option`, formData).then(response => {
                    console.log(response);
                    const newOption = response.data.data;
                    this.$router.push({
                        name:'option.edit.packaging.index',
                        params:{
                            option: newOption.id,
                        },
                    });
                    this.isSaving = false;
                }).catch(error => {
                    if(error.response.status === 404){
                        this.noMoreIcons = true;
                        this.isSaving = false;
                    }
                });
            },
            updateOption(){
                this.isSaving = true;
                let formData = new FormData();
                formData.append('title', this.option.title);
                formData.append('description', this.option.description);
                formData.append('price', this.option.price);
                formData.append('as_extra_price', this.option.as_extra_price);
                formData.append('packaging_price', this.option.packaging_price);

                formData.append('sold_out', this.option.sold_out ? 1 : 0);

                this.option.tags.forEach((tag)=>{
                    formData.append('tags[]', tag);
                })


                if(this.option.image !== this.originalImage){
                    formData.append('image', this.option.image);
                    formData.append('image_name', this.option.image_name);
                }

                axios.post(`/api/admin/option/${this.$route.params.option}`, formData).then(response => {
                    this.$router.push({
                        name:'option.edit.packaging.index',
                        params:{
                            option: this.$route.params.option,
                        }
                    });
                    this.isSaving = false;
                });
            },
            toggleTag(id){
                console.log(id);
                if(this.option.tags.includes(id)){
                    this.option.tags = this.option.tags.filter(item => item !== id);
                }else{
                    this.option.tags.push(id);
                }
            }
		},
		created(){
            this.$store.dispatch('getTags');
            if(!this.isCreating){
                axios.get(`/api/admin/option/${this.$route.params.option}`).then(response => {
                    response.data.data.image_name = '';
                    this.option = response.data.data;
                    this.originalImage = response.data.data.image;
                    this.option.tags = this.option.tags.map(item => item.id);
                });
			}
		}
    }
</script>

<style scoped>

</style>
